package gr.tech.GRAttestation.components.modals

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.GRAttestation.util.Constants
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

val ModalOverlayStyle = com.varabyte.kobweb.silk.style.CssStyle {
    base {
        Modifier
            .position(Position.Fixed)
            .top(0.px)
            .left(0.px)
            .width(100.percent)
            .height(100.percent)
            .backgroundColor(rgba(0, 0, 0, 0.5))
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
            .padding(1.cssRem)
            .zIndex(Constants.DESIGN.MODAL_OVERLAY_INDEX)
            .animation(
                ModalOverlayFadeInAnimation.toAnimation(
                    duration = 0.3.s,
                    timingFunction = AnimationTimingFunction.EaseInOut,
                    iterationCount = AnimationIterationCount.of(1)
                )
            )
    }
}

val ModalContentAnimation = com.varabyte.kobweb.silk.style.CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .animation(
                ModalContentSlideUpAnimation.toAnimation(
                    duration = 0.3.s,
                    timingFunction = AnimationTimingFunction.EaseInOut,
                    iterationCount = AnimationIterationCount.of(1)
                )
            )
    }
}

val ModalOverlayFadeInAnimation = Keyframes {
    from {
        Modifier.opacity(0)
    }
    to {
        Modifier.opacity(1)
    }
}

val ModalContentSlideUpAnimation = Keyframes {
    from {
        Modifier
            .translateY(20.px)
            .opacity(0)
    }
    to {
        Modifier
            .translateY(0.px)
            .opacity(1)
    }
}

@Composable
fun ModalOverlay(
    isOpen: Boolean,
    onClose: () -> Unit,
    content: @Composable () -> Unit
) {
    if (isOpen) {
        Div(
            attrs = ModalOverlayStyle.toModifier()
                .onClick { onClose() }
                .toAttrs()
        ) {
            Column(
                modifier = ModalContentAnimation.toModifier().attrsModifier {
                    onClick {
                        it.stopPropagation()
                    }
                },
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center
            ) {
                content()
            }

        }
    }
}



